import { type DocumentData, where } from "firebase/firestore";
import { runInAction } from "mobx";
import { firestoreApi } from "../../core/apis/firestoreApi";
import BaseApi from "../../core/BaseApi";
import { DbInfoType } from "../../dev/DevsStore";
import { log } from "../../ui/log";
import {
  BusinessScheduleItem,
  type BusinessScheduleItemData,
} from "./BusinessScheduleItem";

export default class BusinessScheduleItemApi extends BaseApi<
  BusinessScheduleItem,
  BusinessScheduleItemData
> {
  /* PRIVATE APIS */

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_schedule`;
  }

  get store() {
    return this.stores.businessScheduleStore;
  }

  watchScheduleDataForBusinessPlanUid(businessPlanUid: string) {
    this.stores.devsStore.addDbStats(
      DbInfoType.WatchAdded,
      this.db,
      businessPlanUid,
    );
    if (__DEV__) {
      log.network(
        `Started watchScheduleDataForBusinessPlanUid from db ${this.db} businessPlanUid ${businessPlanUid}`,
      );
    }

    const unsubscribe = firestoreApi.subscribeToQuery(
      this.db,
      [where("businessPlanUid", "==", businessPlanUid)],
      (querySnapshot) => {
        runInAction(() => {
          const addData: BusinessScheduleItem[] = [];
          const deleteData: string[] = [];

          querySnapshot
            .docChanges()
            .forEach((change: { doc: DocumentData; type: string }) => {
              if (!change.doc.metadata.hasPendingWrites) {
                this.stores.devsStore.addDbStats(
                  DbInfoType.WatchItem,
                  this.db,
                  change.doc.id,
                );
              }

              if (change.type === "added" || change.type === "modified") {
                try {
                  addData.push(this.fromFirestore(change.doc));
                } catch (e) {
                  console.error(e);
                }
              }

              if (change.type === "removed") {
                deleteData.push(change.doc.id);
              }
            });

          if (addData.length) {
            /*if (__DEV__ && ) {
          log.network("Got watchDataForModuleUid updated data", addData);
        }*/
            this.store.load(addData);
          }

          if (deleteData.length) {
            /*if (__DEV__) {
          log.network("Got watchDataForModuleUid delete data", deleteData);
        }*/

            deleteData.forEach((d) => {
              this.store.deleteItem(d);
            });
          }
        });
      },
    );

    return () => {
      this.stores.devsStore.addDbStats(
        DbInfoType.WatchRemoved,
        this.db,
        businessPlanUid,
      );
      unsubscribe();
    };
  }
  fromFirestore(res: DocumentData): BusinessScheduleItem {
    return new BusinessScheduleItem(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
